// Plain helpers for the e-sign audit trail and fingerprints shown on an envelope.

export function shortHash(hex) {
  if (!hex || typeof hex !== 'string') return '';
  return hex.length > 24 ? `${hex.slice(0, 12)}…${hex.slice(-8)}` : hex;
}

const pad = (n) => String(n).padStart(2, '0');

// "2026-10-12 13:51" in the viewer's own time zone; '' for anything unparseable.
export function ledgerTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// The audit rows to show, oldest first, each with a "who" line that never repeats blanks.
export function trailRows(audit) {
  if (!Array.isArray(audit)) return [];
  return audit
    .filter((e) => e && (e.label || e.event))
    .map((e) => ({
      time: ledgerTime(e.at),
      event: e.label || e.event,
      who: e.name || e.email || (e.event === 'completed' || e.event === 'filed' ? 'Bricks' : ''),
      ip: e.ip || '',
      browser: e.browser && e.browser !== '-' ? e.browser : '',
      note: e.note || '',
      userAgent: e.user_agent || '',
    }));
}

// Fingerprint rows for the envelope, or [] when nothing has been hashed yet.
export function fingerprintRows(env) {
  if (!env) return [];
  const rows = [];
  if (env.original_sha256) {
    rows.push({ key: 'original', label: 'Original SHA-256', hash: env.original_sha256,
      note: env.original_sha256_mismatch ? 'Changed after it was sent. The signed PDF says so.' : '' });
  }
  if (env.signed_sha256) rows.push({ key: 'signed', label: 'Signed PDF SHA-256', hash: env.signed_sha256, note: '' });
  return rows;
}

export function flattenedLine(n) {
  if (n === undefined || n === null) return '';
  if (!n) return 'No fillable fields in the original';
  return `${n} fillable field${n === 1 ? '' : 's'} flattened, so the signed PDF can't be edited`;
}
